import './GrandLayout.css'
import { useEffect } from "react";
import { HeaderProvider } from "../../context/Header/HeaderContext";
import GrandNavbar from "../../features/GrandPage/GrandNavbar/GrandNavbar";
import Lenis from 'lenis';
import FooterContainer from '../../components/Footer/FooterContainer/FooterContainer';

export default function GrandLayout({children}) {

    useEffect(() => {
        const lenis = new Lenis()
        function raf(time){
            lenis.raf(time)
            requestAnimationFrame(raf)
        }
        requestAnimationFrame(raf)
    }, [])

     


    return (
        <main className="GrandLayout-main-container">
            <HeaderProvider>
                <GrandNavbar />
            </HeaderProvider>

            {children}
            <FooterContainer isGrand/>
        </main>
    )
}